import Switch, { SwitchProps } from "@mui/material/Switch";
import { EmtIconProps } from "./EmtIcon";

export type EmtSwitchProps = SwitchProps & {
  icon?: EmtIconProps;
  nonce?: string;
};

export function EmtSwitch(props: EmtSwitchProps) {
  const { ...rest } = props;
  const switchProps = {
    ...rest,
    ...(rest.icon ? { icon: rest.icon, checkedIcon: rest.icon } : {}),
  };
  return (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...switchProps}
    />
  );
}
